import styled from 'styled-components'
import { Button } from '../../base-components'

export const TabContainer = styled.div`
    height: 25em;
    overflow-y: auto;
    padding-right: var(--space-m);

    @media screen and (max-width: 1024px) {
        height: 20em;
        padding-right: var(--space-s);
    }

    @media screen and (max-width: 768px) {
        height: 15em;
        padding-right: var(--space-xs);
    }
`

export const InfoRow = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    gap: var(--space-m);

    @media screen and (max-width: 1024px) {
        gap: var(--space-s);
    }

    @media screen and (max-width: 768px) {
        flex-direction: column;
        gap: var(--space-s);
    }
`

export const ShowDetailsButton = styled(Button)`
    margin-top: var(--space-s);

    @media screen and (max-width: 768px) {
        width: 100%;
        margin-top: var(--space-m);
    }
`

export const PriceSection = styled.div`
    flex: 1;
    max-width: 50%;

    @media screen and (max-width: 1024px) {
        max-width: 60%;
    }

    @media screen and (max-width: 768px) {
        max-width: 100%;
    }
`

export const Container = styled.div`
    padding: var(--space-xl);
    max-width: 1000px;
    width: 60em;

    @media screen and (max-width: 1200px) {
        width: 85vw;
        max-width: 85vw;
    }

    @media screen and (max-width: 1024px) {
        width: 90vw;
        max-width: 90vw;
        padding: var(--space-l);
    }

    @media screen and (max-width: 768px) {
        width: 95vw;
        max-width: 95vw;
        padding: var(--space-m);
    }
`

export const Title = styled.h2`
    @media screen and (max-width: 768px) {
        font-size: 1.5em;
        margin-bottom: var(--space-s);
    }
`

export const Subtitle = styled.p`
    @media screen and (max-width: 768px) {
        font-size: 1.1em;
        margin-bottom: var(--space-s);
    }
`

export const Footer = styled.div`
    display: flex;
    justify-content: flex-end;
    margin-top: var(--space-l);
`

export const FooterButtonsContainer = styled.div`
    display: flex;
    justify-content: flex-end;

    @media screen and (max-width: 1024px) {
        flex-wrap: wrap;
        gap: var(--space-s);
    }

    @media screen and (max-width: 768px) {
        flex-direction: column;
        gap: var(--space-s);
        align-items: stretch;
    }
`

export const FooterButton = styled(Button)`
    margin-left: var(--space-m);

    @media screen and (max-width: 1024px) {
        margin-left: 0;
        margin-right: var(--space-s);
        
        &:last-child {
            margin-right: 0;
        }
    }

    @media screen and (max-width: 768px) {
        margin-left: 0;
        margin-right: 0;
        width: 100%;
    }
`

export const InfoText = styled.p`
    margin-top: var(--space-m);
    margin-bottom: 0;
    padding-bottom: 0;
    color: var(--color-red);
`

export const UnknownItemsLine = styled.div`
    margin-top: var(--space-m);
    display: flex;
    align-items: center;
    gap: var(--space-xs);

    @media screen and (max-width: 768px) {
        flex-direction: column;
        align-items: flex-start;
        gap: var(--space-s);
    }
`

export const UnknownItemsLabel = styled.span`
    position: relative;
`

export const UnknownItemsList = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: var(--space-xs);
    min-width: 0;
    line-height: 1.5;

    @media screen and (max-width: 768px) {
        width: 100%;
        justify-content: flex-start;
    }
`

export const UnknownItemBadge = styled.span`
    padding: var(--space-xxs) var(--space-xs);
    border-radius: 2px;
    border: 1px solid var(--color-grey-15);
    flex-shrink: 0;

    @media screen and (max-width: 768px) {
        padding: var(--space-xxs) var(--space-s);
        font-size: 0.9em;
    }
`

export const SpinnerContainer = styled.div`
    display: flex;
    justify-content: center;
`
